import { crmCustomerBrandStatuses } from "common/config";
import { isKanda } from "common/functions";
import React from "react";
import { ThemeProvider as SThemeProvider } from "styled-components";

const theme = {
  colors: {
    crmCustomerBrandStatuses: {
      [crmCustomerBrandStatuses.ORDERED]: "#219C90",
      [crmCustomerBrandStatuses.NOT_OFFERED_YET]: "#FFF455",
      [crmCustomerBrandStatuses.REJECTED]: "#EE4E4E",
      [crmCustomerBrandStatuses.AWAITING_REORDER]: "#33825B",
      [crmCustomerBrandStatuses.FOLLOW_UP]: "#ccfbfe",
      [crmCustomerBrandStatuses.OFFERED]: "#CDACA1",
    },
    danger: "#ED172B",
    lightestGrey: "#F2F2F2",
    lighterGrey: "#DBDBDB",
    lightGrey: "#a4a4a4",
    black: "#333333",
    primary: isKanda() ? "pink" : "#ff9696",
    secondary: isKanda() ? "#333333" : "#213236",
    success: "#2A9A4E",
    white: "#FFFFFF",
  },
  breakpointXs: "600px",
  breakpointS: "900px",
  headerHeight: "60px",
};

const ThemeProvider = ({ children }) => {
  return <SThemeProvider theme={theme || {}}>{children}</SThemeProvider>;
};

export { ThemeProvider, theme };
